module.exports = __webpack_public_path__ + "10_hige_white.c90b9d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/10_hige_white.png
// module id = MV4W
// module chunks = 0